import { AbstractDocumentAuxiliarField } from './abstract-document-auxiliar-field';
export class DocumentAuxiliarSelectField implements AbstractDocumentAuxiliarField
{ 
    id: string;
    type: string = "select"
    label: string;
    options: string[] = [];
    value: any;
}